import { Box, Typography } from "@mui/material"
import { ViewOpportunityButtonWrapper } from "./Atom"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { setOpportunitySelectedGroupByRole } from "../../../redux/slices/metricSlice"

const ViewOpportunityButton = (props: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const metricOpportunityHeaderFilterSelectedGroup = useSelector(
    (state: any) => {
      return state.metric?.metricOpportunityHeaderFilterSelectedGroup
    },
  )

  return (
    <ViewOpportunityButtonWrapper
      onClick={async () => {
        await dispatch(
          setOpportunitySelectedGroupByRole({
            ...metricOpportunityHeaderFilterSelectedGroup,
          }),
        )
        // console.log("metricOpportunityHeaderFilterSelectedGroup", metricOpportunityHeaderFilterSelectedGroup);

        navigate("/opportunity-dashboard")
      }}
    >
      <Typography>View Opportunities</Typography>
    </ViewOpportunityButtonWrapper>
  )
}

export default ViewOpportunityButton
